import api from "../../services/apiEndpoints";
import _ from "lodash";
import $ from "jquery";

export const clientsMixin = {
    methods: {
        newGetClients(user, firstTime = false) {
            let userId = user.user.id;

            this.$http
                .get(
                    api.actions.get_stylist_clients +
                        "?stylist_id=" +
                        userId +
                        "&page=" +
                        this.newPage[userId] +
                        "&search=" +
                        this.newSearch,
                )
                .then(
                    function (response) {
                        if (typeof response.data.clients != "undefined") {
                            if (firstTime) {
                                this.newClients[userId] = response.data.clients;
                                if (userId == this.newCurrentStylistId) {
                                    this.newPagedClients = response.data.clients;
                                }
                                this.originalLoadMore[userId] = response.data.loadMore;
                            } else {
                                if (this.newPage[userId] != 1) {
                                    this.newPagedClients = this.newPagedClients.concat(response.data.clients);
                                } else {
                                    //for first page, replace the results
                                    this.newPagedClients = response.data.clients;
                                }
                            }

                            this.newPage[userId]++;

                            this.newLoadMore[userId] = response.data.loadMore;
                            //in case we are landing here from clients page
                            //then client should be auto selected
                            if (
                                typeof this.selectedClient != "undefined" &&
                                this.selectedClient != null &&
                                this.selectedClient
                            ) {
                                this.newManageSelectedClient();
                            }
                        }
                        this.numberOfDataFetched++;
                        this.newMakeEvents();
                    }.bind(this),
                    function () {
                        return false;
                    },
                );
        },

        newManageSelectedClient() {
            if (this.selectedClient) {
                this.newSelectedClientF(this.selectedClient);
            }

            //trigger open the book appointment modal
            this.newOnDateClick({
                date: moment().toDate(),
            });
        },

        newSelectedClientF(pagedClient) {
            this.newIsClientSelected = true;
            this.newSelectedModalClient = pagedClient;
            $("#add-client-modal").slideUp();
            this.newManageSaveAppointmentButton();
        },

        getFreshClients() {
            this.searchDebouncedClients(this);
        },

        searchDebouncedClients: _.debounce((self) => {
            self.newPage[self.newCurrentStylist["user"]["id"]] = 1;
            self.newGetClients(self.newCurrentStylist, true);
        }, 500),

        openModal(type) {
            switch (type) {
                case "client":
                    if (this.newSearch != "") {
                        this.newSearch = "";
                        this.newGetClients(this.newCurrentStylist, true);
                    }
                    this.resetAddNewClientErrors();
                    $("#add-client-modal").slideToggle();
                    $("#add-service-modal").slideUp();
                    break;
                case "service":
                    if (this.newSearchQuery != "") {
                        this.newSearchQuery = "";
                    }
                    $("#add-service-modal").slideToggle();
                    $("#add-client-modal").slideUp();
                    this.newMakeListServices();
                    break;
                case "pickDate":
                    this.openDateModal = true;
                    break;
                case "pickApptDate":
                    this.openApptDetailsDateModal = !this.openApptDetailsDateModal;
                    break;
            }
        },

        resetSearchClient() {
            this.newSearch = "";
            this.resetClientObj();
            this.resetData();
        },

        resetAddNewClientErrors() {
            this.phoneError = "";
            this.editClientObjErrors.first_name = null;
            this.editClientObjErrors.last_name = null;
            this.editClientObjErrors.phone = null;
        },

        displayAddClientForm() {
            if (this.adminDetails.group_active && this.adminDetails.group_owner) {
                this.getGroupsMembers(this.adminDetails.group_id);
            }
            this.displayNewClientForm = true;
        },

        resetClientObj() {
            this.editClientObj = {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
            };
            this.editClientStylists = [];
            this.displayNewClientForm = false;
            this.displayNewServicesForm = false;
            this.resetAddNewClientErrors();
        },

        saveClientLink(client_id) {
            let data = {
                client_id: client_id,
                stylists: {},
            };

            this.groupMembers.forEach((el) => {
                data.stylists[el.user.id] = {
                    active: this.editClientStylists.indexOf(el.user.id) !== -1,
                };
            });

            this.$http.post(api.actions.save_group_stylists_client_link, data).then(
                function (response) {
                    if (response.data.error == false) {
                        this.showClientsEditForm = false;
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                        this.resetClientObj();
                        this.newPage[this.newCurrentStylist["user"]["id"]] = 1;
                        this.newGetClients(this.newCurrentStylist);
                    }
                }.bind(this),
                function () {
                    return false;
                },
            );
        },

        saveClient() {
            if (
                this.editClientObj.first_name === "" ||
                this.editClientObj.last_name === "" ||
                this.editClientObj.phone === ""
            ) {
                this.validateClient();
                this.scrollToElement();
                return;
            }

            if (!this.validatePhoneNumber(this.editClientObj.phone)) {
                return;
            }

            if (
                this.adminDetails.group_active &&
                this.adminDetails.group_owner &&
                this.editClientStylists.length == 0
            ) {
                messages.errorMessage(messages.ERROR_MESSAGES.ADD_CLIENT_STYLISTS_ERROR);
                return;
            }

            let data = {
                first_name: this.editClientObj.first_name,
                last_name: this.editClientObj.last_name,
                phone: this.editClientObj.phone,
                email: this.editClientObj.email,
            };

            this.checkExistingTeamMemberUser().then((response) => {
                if (response.data.exists == true) {
                    this.inviteEmail = this.editClientObj.email;
                    this.invitePhoneNumber = this.editClientObj.phone;
                    this.sendInvite();
                    this.newSelectedClientF(response.data.user);
                    this.resetClientObj();
                    this.newPage[this.newCurrentStylist["user"]["id"]] = 1;
                    this.newGetClients(this.newCurrentStylist);
                    return;
                } else {
                    this.$http.post(api.actions.add_client_user, data).then(
                        function (response) {
                            if (response.data.error == false) {
                                this.newSelectedClientF(response.data.user);

                                if (this.adminDetails.group_active && this.adminDetails.group_owner) {
                                    this.saveClientLink(response.data.user.id);
                                    return;
                                }

                                this.displayNewClientForm = false;
                                messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);

                                this.resetClientObj();
                                this.newPage[this.newCurrentStylist["user"]["id"]] = 1;
                                this.newGetClients(this.newCurrentStylist);
                            }
                        }.bind(this),
                    );
                }
            });
        },

        validatePhoneNumber(phoneNumber) {
            const phoneNumberRegex = /^[0-9]*$/;

            if (!phoneNumberRegex.test(phoneNumber)) {
                this.phoneError = "Please enter only numbers";
                this.scrollToElement();

                return false;
            } else {
                this.phoneError = "";

                return true;
            }
        },
        
        validateClient() {
            this.resetErrors(); // Clear any previous error messages

            let validField = true;

            // Validate first name
            if (!this.editClientObj.first_name) {
                this.editClientObjErrors.first_name = "First name is required";
                validField = false;
            }

            // Validate last name
            if (!this.editClientObj.last_name) {
                this.editClientObjErrors.last_name = "Last name is required";
                validField = false;
            }

            // Validate phone number
            if (!this.editClientObj.phone) {
                this.editClientObjErrors.phone = "Phone number is required";
                validField = false;
            } else if (!/^\d+$/.test(this.editClientObj.phone)) {
                this.editClientObjErrors.phone = "Phone number must be digits only";
                validField = false;
            }
        },

        // Method to clear error for a specific field when the user starts typing
        clearError(field) {
            this.editClientObjErrors[field] = null;
        },

        // Reset all error messages
        resetErrors() {
            this.editClientObjErrors = {
                first_name: null,
                last_name: null,
                phone: null,
            };
        },
    },
};
